import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import InputField from "@frameworks/web/components/generic/inputField";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import { useNavigate } from "react-router-dom";
import { getQueryParameterName } from "../../../../utils/urlHelper";
import di from "../di/servicelocator";
import { loginHelp } from "../LogintextConfig";
import ErrorExclamation from "@frameworks/web/components/generic/errorExclamation";
import * as URLConfig from "@frameworks/web/config/domain";
import { handleNavigateUrl, loginScreenState } from "../constant";
import { useSelector } from "react-redux";
const config = URLConfig.config;
const inputfield = {
    newpass: "",
    reenter: "",
};
export const LogInWelcomePage = (props) => {
    const device = DeviceContext();
    let navigate = useNavigate();
    const [pwdButtonDisable, setPwdButtonDisable] = React.useState(false);
    const { data: accountsData, loader: accountsDataLoader, errorData: accountsDataError, } = useSelector((state) => state.LoginFlow.ClientLoginDataReducers);
    const { data: ClientValPass, loader: ClientValPassLoader, errorData: ClientValPassError, } = useSelector((state) => state.LoginFlow.ClientValPassword);
    const accType = getQueryParameterName("accType");
    const [mainAccType, setMainAccType] = React.useState();
    const [pwd, setPwd] = useState("");
    const [isRevealPwd, setIsRevealPwd] = useState(false);
    const [error, setError] = useState(inputfield);
    const guestValidateMpin = useSelector((state) => state.LoginFlow.guestValidateMPIN.data);
    const handleChange = (val) => {
        setPwdButtonDisable(false);
        setPwd(val);
        if (val.length === 0) {
            setIsRevealPwd(false);
        }
    };
    const get2FaQuestionData = () => {
        // setPwdError({ errorDetails: { isOpen: false, error: null }, count: 0 });
        props === null || props === void 0 ? void 0 : props.setAccType(mainAccType
            ? mainAccType
            : accType
                ? accType
                : accountsData.accountTypesArray[0]);
        if (accountsData.userID &&
            ((accType !== undefined && accType !== null && accType !== "") ||
                (mainAccType !== undefined &&
                    mainAccType !== null &&
                    mainAccType !== "") ||
                accountsData.accountTypesArray[0])) {
            let requestPayload = {
                userId: accountsData.userID,
                accType: mainAccType
                    ? mainAccType
                    : accType
                        ? accType
                        : accountsData.accountTypesArray[0],
                ip: "",
                pwd: pwd,
                vndSrc: null,
            };
            di.login.getQuestionsData(requestPayload);
        }
    };
    const errorHandling = () => {
        let errCd = ClientValPassError.error.getErrCd();
        switch (errCd.toString()) {
            case "ELGN0002":
                return (pwdButtonDisable && (React.createElement(ErrorExclamation, { errorMessage: loginHelp.invalidPassword, avoidBackground: true, parentClass: " " })));
            case "ELGN0004":
                return null;
            default:
                return (pwdButtonDisable && (React.createElement(ErrorExclamation, { errorMessage: ClientValPassError.error.getErrorMessageOrErrMsg(), parentClass: " " })));
        }
    };
    React.useEffect(() => {
        if ((props === null || props === void 0 ? void 0 : props.accType) !== undefined &&
            (props === null || props === void 0 ? void 0 : props.accType) !== null &&
            (props === null || props === void 0 ? void 0 : props.accType) !== "") {
            setMainAccType(props === null || props === void 0 ? void 0 : props.accType);
        }
    }, [props === null || props === void 0 ? void 0 : props.accType]);
    React.useEffect(() => {
        if (!ClientValPassLoader && !ClientValPassError.isOpen) {
            if (ClientValPass.isOtpSucesss) {
                if (props.setScreenState) {
                    props === null || props === void 0 ? void 0 : props.setScreenState(loginScreenState.OTP);
                }
                if ((props === null || props === void 0 ? void 0 : props.setOtpStateObj) !== undefined &&
                    (props === null || props === void 0 ? void 0 : props.setOtpStateObj) !== null &&
                    typeof (props === null || props === void 0 ? void 0 : props.setOtpStateObj) === "function") {
                    props === null || props === void 0 ? void 0 : props.setOtpStateObj({
                        pwd: pwd,
                        accType: accType,
                        resendOTPPayload: {
                            userId: accountsData.userID,
                            accType: mainAccType
                                ? mainAccType
                                : accType
                                    ? accType
                                    : accountsData.accountTypesArray[0],
                            ip: "",
                            pwd: pwd,
                            vndSrc: null,
                        },
                    });
                }
            }
        }
        else if (!ClientValPassLoader &&
            ClientValPassError.isOpen &&
            !pwdButtonDisable) {
            setPwdButtonDisable(true);
        }
    }, [ClientValPassLoader, ClientValPassError, ClientValPass]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "clientLogin" },
            React.createElement("div", { className: "logInMainPage pwdLoginPage NewPassword-block" },
                React.createElement(GridContainer, { parentClass: "px-0" },
                    React.createElement(Row, { className: "m-0 pb-30" }, (device === null || device === void 0 ? void 0 : device.isDesktop) ? ("") : (React.createElement(React.Fragment, null,
                        React.createElement(Col, { lg: 12, sm: 12, xs: 12, className: "DMSansBold_20_700 txt-midnight-blue px-0" }, "Login")))),
                    React.createElement(Row, null,
                        React.createElement("div", { className: "mt-md-0 mgt-30" },
                            React.createElement("h6", { className: "DMSansBold_20_700 txt_blackOne1" },
                                "Welcome, ",
                                accountsData.userID,
                                "!"),
                            React.createElement("p", { className: "DMSanN_14_400 txt_primaryGrey" }, accountsData.userID))),
                    React.createElement("form", { id: "clientLogin_form", onSubmit: (e) => {
                            e.preventDefault();
                            get2FaQuestionData();
                        } },
                        React.createElement(Row, { className: "clientLogin_inputfield welcomeLoginValidation" },
                            React.createElement(Col, { lg: 12, sm: 12, xs: 12, className: "mt-40" },
                                React.createElement(InputField, { defaultValue: pwd, onChange: (event) => {
                                        handleChange(event);
                                    }, errorText: error.newpass, placeholder: "Enter your password", id: "newpass", name: "newpass", type: isRevealPwd ? "text" : "password", required: false, autoComplete: "off", autofocus: true, showLabel: true, prefix: pwd.length > 0 && (React.createElement("i", { className: `edel-icon-${isRevealPwd ? "eye-show" : "eye-hide"} icon hand_cursor`, onClick: () => setIsRevealPwd((prevState) => !prevState) })), placeholderClassName: `floating-label `, className: `custom-form-control ${pwdButtonDisable && "Error-border-custom"}` })),
                            React.createElement("div", null,
                                React.createElement("div", { className: "d-flex justify-content-between  align-items-center mb-15" },
                                    React.createElement("div", null, !ClientValPassLoader &&
                                        ClientValPassError.isOpen &&
                                        pwdButtonDisable &&
                                        errorHandling()),
                                    React.createElement("label", { className: "borderedText" },
                                        React.createElement(EdButton, { btnTyp: "link", className: "no_bg txt-midnight-blue DMSansNormal_12_400 midnight-blue-underline", onClick: () => {
                                                di.login.flushLoginError();
                                                di.login.flushLoginData();
                                                if (props.helpFlowPopup) {
                                                    props.helpFlowPopup(loginScreenState.FORGOT_PASSWORD);
                                                }
                                                else {
                                                    props.redirectUrl
                                                        ? navigate("/forgotpassword?redirectUrl=" +
                                                            encodeURIComponent(props.redirectUrl), {
                                                            replace: true,
                                                        })
                                                        : navigate("/forgotpassword");
                                                }
                                            }, type: "button", value: "Forgot Password?" })))),
                            React.createElement("div", null)),
                        !ClientValPassLoader &&
                            ClientValPassError.isOpen &&
                            ClientValPassError.error.getErrCd() === "ELGN0004" && (React.createElement("div", { className: "invalidMsg DMSanM_14_500 txt_bloodRed bg_lightPinkTwo brdradius-5 mb-15" },
                            React.createElement("div", { className: "d-flex align-items-center " },
                                React.createElement("span", { className: "p-2" },
                                    loginHelp.accountBlocked,
                                    " Click here to",
                                    "  ",
                                    React.createElement(EdButton, { btnTyp: "midnight-blue-underline", className: "no_bg txt-midnight-blue DMSansNormal_12_400 small-edbutton", onClick: () => {
                                            di.login.flushLoginData();
                                            di.login.flushLoginError();
                                            if (props.helpFlowPopup) {
                                                props.helpFlowPopup(loginScreenState.UNBLOCK_USER);
                                            }
                                            else {
                                                props.redirectUrl
                                                    ? navigate("/unblock-user?redirectUrl=" +
                                                        encodeURIComponent(props.redirectUrl), {
                                                        replace: true,
                                                    })
                                                    : navigate("/unblock-user");
                                            }
                                        }, value: " Unblock account", type: "button" }))))),
                        React.createElement(Row, { className: "mt-15" },
                            React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Next", disabled: !pwd || ClientValPassLoader || pwdButtonDisable, 
                                // onClick={() => get2FaQuestionData()}
                                type: "submit", className: "m-0" })),
                        React.createElement(Row, { className: "clientLogin_unblockLink mt-15" },
                            React.createElement(Col, { lg: 12 },
                                React.createElement("div", null,
                                    React.createElement("p", { className: "txt_primaryGrey DMSanN_14_400 text-center" },
                                        "Not you?\u00A0",
                                        React.createElement(EdButton, { btnTyp: "midnight-blue-underline", className: "no_bg midnight-btn-underline small-edbutton", onClick: () => {
                                                di.login.flushLoginData();
                                                di.login.flushLoginError();
                                                props === null || props === void 0 ? void 0 : props.setScreenState(loginScreenState.LOGIN);
                                            }, value: "Switch account", type: "button" })))))),
                    React.createElement(Row, null,
                        React.createElement(Col, null,
                            React.createElement("div", { className: "divider divider-15" },
                                React.createElement("div", null,
                                    React.createElement("p", { className: "DMSanN_14_400 txt_primaryGrey" }, "Or"))))),
                    React.createElement(Row, { className: "m-0 deskBtn" },
                        React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Open an Account", className: "openAccnt", onClick: () => {
                                window.open(config.accOpeningUrl);
                            }, type: "button" }),
                        React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Continue as Guest", type: "button", onClick: () => {
                                navigate(handleNavigateUrl("/guest-login", props.redirectUrl), {
                                    replace: true,
                                });
                                di.login.flushLoginData();
                            }, disabled: guestValidateMpin.status })),
                    React.createElement(Row, { className: "clientLogin_unblockLink mt-0" },
                        React.createElement(Col, { lg: 12, className: "d-flex justify-content-center" },
                            React.createElement("p", { className: "txt_primaryGrey DMSanN_14_400 removecapitalize" },
                                "Account blocked?\u00A0",
                                React.createElement(EdButton, { btnTyp: "midnight-blue-underline", className: "small-edbutton", onClick: () => {
                                        di.login.flushLoginError();
                                        if (props.helpFlowPopup) {
                                            props.helpFlowPopup(loginScreenState.UNBLOCK_USER);
                                        }
                                        else {
                                            navigate(handleNavigateUrl("/unblock-user", props.redirectUrl), {
                                                replace: true,
                                            });
                                        }
                                    }, value: "Click here to unblock", type: "button" })))))))));
};
